<script setup>

const props = defineProps({
  id: String,
  required: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: 'text'
  },
  placeholderText: String,
  errorText: {
    type: String,
    default: ''
  },
  modelValue: String,
  invalidText: String
});

const { checkInputFields } = useLeadGenData();

const state = ref('');
const emit = defineEmits(['onChanged', 'onKeyPress']);
const fieldValue = ref(props.modelValue);
const errorMessage = ref(props.errorText);
const isInvalid = ref(false);
const inputRef = ref(null);

const handleState = (status) => {
  state.value = status;
  isInvalid.value = true;
};

defineExpose({
  handleState,
  runValidation: () => handleValidation(),
})

const handleValidation = () => {
  if (((fieldValue.value === '' || fieldValue.value == undefined) && props.required) || checkInputFields(fieldValue.value)) {
    state.value = 'invalid';            
    isInvalid.value = false;   
  } else if (props.type === 'email' && fieldValue.value && inputRef.value && !inputRef.value.checkValidity()) {
    state.value = 'invalid';
    isInvalid.value = true;
  } else {
    state.value = 'valid';
    isInvalid.value = false;
  }   
  
  emit('onChanged', {
    id: props.id,
    value: fieldValue.value,
    valid: state.value === 'valid'
  });
};

const handleChange = (event) => {
  fieldValue.value = event.target.value;
  handleValidation();
};

const handleKeyPress = (event) => {  
  emit('onKeyPress', {
    id: props.id,
    value: event.target.value,
    valid: state.value === 'valid'
  });
};

const computedClasses = computed(() => {  
  return {    
    'form-control': true,
    'is-invalid': state.value === 'invalid',
  };
});

const errorMessageText = computed(() => {  
  return isInvalid.value ? props.invalidText : props.errorText;
});

const errorLabelClasses = computed(() => {  
  return {    
    'error-label': true,    
    'd-none': state.value === 'valid',
    'd-block': state.value === 'invalid',
  };
});

const placeholderLabelClasses = computed(() => {  
  return {    
    'placeholder-label': true, 
    'd-block': state.value === 'valid',
    'd-none': state.value === 'invalid',
  };
});

</script>

<template>
  <div class="form-floating">
    <input 
      ref="inputRef"
      :id="id"
      :class="computedClasses"
      :type="type" 
      :required="required"
      v-model="fieldValue"      
      :placeholder="placeholderText" 
      @input="handleChange"
      @keypress="handleKeyPress"
    />
    <label :for="id" :class="placeholderLabelClasses">{{ placeholderText }}</label>
    <label :for="id" :class="errorLabelClasses">{{ errorMessageText }}</label>
  </div>
</template>

<style lang="scss" scoped>
.form-floating {
  label {
    line-height: 1;
  }
  .form-control {
    height: calc(3rem + 2px)
  }
  .error-label {
    display: none;
    color: $color-error;
  }

  .placeholder-label {
    display: block;
  }

  &.is-invalid {
    .error-label {
      display: block;
    }

    .placeholder-label {
      display: none;
    }
  }
}
</style>
